import React, { useState } from 'react'
import { Box, Button, CircularProgress, useToast, Text, Heading } from '@chakra-ui/react'
import { useFormik } from 'formik';
import FormInputPassword from '../../components/form/FormInputPassword';
import LayoutView from '../../components/layout';
import { useMutation } from 'react-query'
import { updateWorkerPasswordApi } from '../../api/workers';

const Password = () => {
  const toast = useToast()
  const [error, setError] = useState('')

  const updatePatientPasswordMutation = useMutation(updateWorkerPasswordApi, {
    onSuccess: res => {
      toast({
        title: 'Password updated',
        description: "Your password has been succesfully updated",
        status: 'success',
        duration: 3000,
        isClosable: true
      })
      formik.setValues({
        password: '',
        newPassword: '',
        confirmNewPassword: '',
      })
      setError('')
    },
    onError: err => setError(err.response?.data?.msg)
  })

  const formik = useFormik({
    initialValues: {
      password: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    onSubmit: (values) => {
      setError('');
      updatePatientPasswordMutation.mutate(values)
    }
  })

  return (
    <LayoutView activePage="Change password">
      <Box p={{ base: "5", md: "8" }} maxW="600px" mx="auto" w="full" bg="white" borderRadius="2xl" boxShadow="card">
        <Heading size="md">Change your password</Heading>
        <Text mt="1" mb="6" color="gray.500">Choose a strong password you do not use elsewhere.</Text>
        <form onSubmit={formik.handleSubmit}>
            <FormInputPassword
              mt='4'
              label='Current password'
              id='password'
              placeholder="Your current password"
              onChange={formik.handleChange('password')}
              value={formik.values.password}
              error={formik.errors.password}
            />
            <FormInputPassword
              mt='4'
              label='New Password'
              type="password"
              id='newPassword'
              placeholder="Your new password"
              onChange={formik.handleChange('newPassword')}
              value={formik.values.newPassword}
              error={formik.errors.newPassword}
            />
            <FormInputPassword
              mt='4'
              label='Confirm New Password'
              type="password"
              id='confirmNewPassword'
              placeholder="Confirm New Password"
              onChange={formik.handleChange('confirmNewPassword')}
              value={formik.values.confirmNewPassword}
              error={formik.errors.confirmNewPassword}
            />
          <Text color='red.500' textAlign={'center'} mt='2'>{error}</Text>
          <Button width="full" mt={6} type="submit">
            {updatePatientPasswordMutation.isLoading ? (
              <CircularProgress isIndeterminate size="24px" color="teal" />
            ) : (
              'Change password'
            )}
          </Button>
        </form>
      </Box>
    </LayoutView>
  )
}

export default Password
